export default __webpack_public_path__ + "static/media/contact3XS.3816e9e8.webp";